import React, { useEffect, useState } from 'react';
import {
  Button,
  FormGroup,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useHook as CustomerHook } from '../useHook';
import { useSelector } from 'react-redux';

const OrganizationDetails = () => {
  const { fetchCustomerInfo, updateCustomerOrgInfo } = CustomerHook();
  const { customerInformation } = useSelector(
    (state: any) => state.profileManagement,
  );
  const [activeEditButton, setActiveButton] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
    clearErrors,
    setValue,
  } = useForm();
  //buttonActive
  const editButtonActive = (fieldName?: any) => {
    setActiveButton(true);
    if (fieldName) {
      clearErrors(fieldName);
    }
  };

  // Set field values
  const customerDetailsFormValue = () => {
    if (customerInformation) {
      setValue('orgNumber', customerInformation.orgNumber || '');
      setValue('orgEmail', customerInformation.orgEmail || '');
      setValue('address', customerInformation.billingAddress || '');
      setValue('tax', customerInformation.taxInformation || '');
      setValue('orgName', customerInformation.orgName || '');
      clearErrors();
    }
  };
  useEffect(() => {
    customerDetailsFormValue();
  }, [customerInformation, setValue]);

  //submit data
  const hadleSubmitOrganizationDetails = async (data: any) => {
    const payload = {
      customerID: customerInformation?.customerID,
      orgNumber: data?.orgNumber,
      orgEmail: data?.orgEmail,
      orgName: data?.orgName,
      billingAddress: data?.address,
      taxInformation: data?.tax,
    };
    await updateCustomerOrgInfo(payload);
    await fetchCustomerInfo();
  };

  //assign mobilenumber
  const handleMobileNumberChange = (event: { target: any; type?: any }) => {
    const inputValue = event.target.value.replace(/\D/g, '');
    event.target.value = inputValue;
    // Update form state with the cleaned value
    register('orgNumber').onChange(event);
    editButtonActive();
  };

  //remove country code error
  const handleCountryCodeChange = (event: { target: { value: any } }) => {
    if (event.target.value) {
      clearErrors('countrycode');
    }
    editButtonActive();
  };

  // Utility function to safely get the error message
  const getErrorMessage = (error: any) => {
    if (!error) return '';
    if (typeof error?.message === 'string') return error.message;
    return 'Invalid input';
  };

  return (
    <>
      <form onSubmit={handleSubmit(hadleSubmitOrganizationDetails)}>
        <section className="personal_details">
          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Organization Name</h4>
              <h5>Will appear on profile and other communications</h5>
            </div>
            <div className="personal_details_card_input_field organization_inputfield">
              <div>
                <TextField
                  variant="outlined"
                  fullWidth
                  {...register('orgName', {
                    required: 'Organization Name is required',
                  })}
                  error={errors.orgName ? true : false}
                  onChange={() => editButtonActive('orgName')}
                />
                {errors.orgName && (
                  <Typography
                    variant="body2"
                    className="personal_details_card_input_field-contact-error"
                  >
                    {getErrorMessage(errors?.orgName)}
                  </Typography>
                )}
              </div>
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Contact Number</h4>
              <h5>Will appear on profile and other communications</h5>
            </div>
            <div className="personal_details_card_input_field">
              <FormGroup>
                <div className="personal_details_card_input_field-contact">
                  <Select
                    className="form-countrycode"
                    {...register('countrycode', {
                      required: 'Country Code is required',
                    })}
                    variant="outlined"
                    error={errors.countrycode ? true : false}
                    onChange={handleCountryCodeChange}
                    defaultValue={'+91'}
                  >
                    <MenuItem value="+91">+91</MenuItem>
                  </Select>
                  <TextField
                    fullWidth
                    {...register('orgNumber', {
                      required: 'Mobile Number is required',
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: 'Phone number must be 10 digits',
                      },
                    })}
                    inputProps={{
                      maxLength: 10,
                    }}
                    onChange={handleMobileNumberChange}
                    variant="outlined"
                    error={errors.orgNumber ? true : false}
                  />
                </div>
                {errors.orgNumber && (
                  <Typography
                    variant="body2"
                    className="personal_details_card_input_field-contact-error"
                  >
                    {getErrorMessage(errors?.orgNumber)}
                  </Typography>
                )}
                {!errors.mobilenumber && errors.countrycode && (
                  <Typography
                    variant="body2"
                    className="personal_details_card_input_field-contact-error"
                  >
                    {getErrorMessage(errors?.countrycode)}
                  </Typography>
                )}
              </FormGroup>
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Organization email</h4>
              <h5>
                Enter your alternative email for reset password or forgot
                password{' '}
              </h5>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('orgEmail', {
                  required: 'email is required',
                  pattern: {
                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                    message: 'Invalid email address',
                  },
                })}
                onChange={() => editButtonActive('orgEmail')}
                error={errors.orgEmail ? true : false}
              />
              {errors.orgEmail && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.orgEmail)}
                </Typography>
              )}
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Billing Address </h4>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('address', { required: 'Address is required' })}
                error={errors.address ? true : false}
                onChange={() => editButtonActive('address')}
              />
              {errors.address && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.address)}
                </Typography>
              )}
            </div>
          </div>

          <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Tax Information </h4>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('tax', { required: 'Tax is required' })}
                error={errors.tax ? true : false}
                onChange={() => editButtonActive('tax')}
              />
              {errors.tax && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.tax)}
                </Typography>
              )}
            </div>
          </div>

          {/* <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>GST Number </h4>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('gst', { required: 'GST Number is required' })}
                error={errors.gst ? true : false}
              />
              {errors.gst && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.gst)}
                </Typography>
              )}
            </div>
          </div> */}

          {/* <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>PAN Number </h4>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('pan', { required: 'PAN Number is required' })}
                error={errors.pan ? true : false}
              />
              {errors.pan && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.pan)}
                </Typography>
              )}
            </div>
          </div> */}

          {/* <div className="personal_details_card">
            <div className="personal_details_card_lable_field">
              <h4>Adhar Number </h4>
            </div>
            <div className="personal_details_card_input_field">
              <TextField
                variant="outlined"
                fullWidth
                {...register('athar', { required: 'Athar Number is required' })}
                error={errors.athar ? true : false}
              />
              {errors.athar && (
                <Typography
                  variant="body2"
                  className="personal_details_card_input_field-contact-error"
                >
                  {getErrorMessage(errors?.athar)}
                </Typography>
              )}
            </div>
          </div> */}

          <div className="personal_details_card_action">
            <Button
              className="personal_details_card_action-edit"
              onClick={customerDetailsFormValue}
            >
              Cancel
            </Button>
            <Button
              className={
                activeEditButton
                  ? 'personal_details_card_action-save'
                  : 'personal_details_card_action-save disable_button_background'
              }
              type="submit"
              disabled={!activeEditButton}
            >
              Save
            </Button>
          </div>
        </section>
      </form>
    </>
  );
};

export default OrganizationDetails;
